import {i18n} from "../../../vue-i18n";

export default class AddLessorComponentShare {
  constructor(id, externalId, assetComponentId, lessorId, startDateDay, startDateMonth, startDateYear, endDateDay, endDateMonth, endDateYear) {
    this.id = id
    this.commandName = 'AddLessorComponentShare'
    this.externalId = externalId
    this.assetComponentId = assetComponentId
    this.lessorId = lessorId

    this.startDateDay = startDateDay
    this.startDateMonth = startDateMonth
    this.startDateYear = startDateYear

    this.endDateDay = endDateDay
    this.endDateMonth = endDateMonth
    this.endDateYear = endDateYear

    this.description = `${i18n.t('CONTENT.events.AddLessorComponentShare')}`
  }

  serialize() {
    const serialisedCommand = JSON.stringify({
      id: this.id,
      ExternalId: this.externalId,
      AssetComponentId: this.assetComponentId,
      LessorId: this.lessorId,
      StartDateDay: this.startDateDay,
      StartDateMonth: this.startDateMonth,
      StartDateYear: this.startDateYear,
      EndDateDay: this.endDateDay,
      EndDateMonth: this.endDateMonth,
      EndDateYear: this.endDateYear,
    });

    return {
      commandName: this.commandName,
      serialisedCommand,
    };
  }

  equal() {
    return false;
  }
}
